/*
 * Copyright (c) 2023. Legalbird eine Marke der R+S Internet Jewels GmbH
 */

import PaymentRunList from "../../PaymentRun/PaymentRunList";

const PaymentRunPage = () => {
  return <PaymentRunList />;
};

export default PaymentRunPage;
